import { io } from 'socket.io-client'

const DEFAULT_SOCKET_URL = 'ws://localhost:3000'

let socket = null
let socketKey = null
let currentTenantId = null

function getSocketUrl() {
  const envUrl = import.meta.env.VITE_WS_URL
  if (envUrl) return envUrl

  const apiUrl = import.meta.env.VITE_API_URL
  if (apiUrl) {
    return apiUrl
      .replace(/^https:/i, 'wss:')
      .replace(/^http:/i, 'ws:')
  }

  if (typeof window !== 'undefined') {
    const proto = window.location.protocol === 'https:' ? 'wss:' : 'ws:'
    return `${proto}//${window.location.host}`
  }

  return DEFAULT_SOCKET_URL
}

function makeKey(url, token) {
  return `${url}::${token || ''}`
}

export function connectRealtime({ token, tenantId }) {
  if (!token || !tenantId) return null

  const socketUrl = getSocketUrl()
  const nextKey = makeKey(socketUrl, token)

  currentTenantId = tenantId

  if (socket && socketKey === nextKey) {
    if (socket.connected) {
      socket.emit('join-tenant', currentTenantId)
    }
    return socket
  }

  disconnectRealtime()

  socketKey = nextKey
  socket = io(socketUrl, {
    auth: { token },
    transports: ['websocket', 'polling'],
    reconnectionDelayMax: 10000
  })

  socket.on('connect', () => {
    if (currentTenantId) {
      socket.emit('join-tenant', currentTenantId)
    }
  })

  socket.on('connect_error', (err) => {
    console.error('WebSocket connect_error:', err?.message || err)
  })

  return socket
}

export function disconnectRealtime() {
  if (!socket) {
    socketKey = null
    return
  }

  try {
    socket.disconnect()
  } catch {
    // ignore
  }

  socket = null
  socketKey = null
}

export function getRealtimeSocket() {
  return socket
}

export function isRealtimeConnected() {
  return Boolean(socket?.connected)
}

export function emitRealtime(event, data) {
  if (!socket) return
  socket.emit(event, data)
}

export function subscribeRealtime(event, callback) {
  if (!socket || typeof callback !== 'function') return () => {}

  socket.on(event, callback)
  return () => {
    try {
      socket.off(event, callback)
    } catch {
      // ignore
    }
  }
}
